export default {
    data: () => ({
        window: {
            width: 0,
            height: 0
        }
    }),
    created() {
        window.addEventListener('resize', this.handleWindowResize);
        this.handleWindowResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleWindowResize);
    },
    methods: {
        handleWindowResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        }
    }
}